import styled, { css } from 'styled-components';
import {
  getTextType,
  getGridSpan,
  getSpace,
  getGridGutter,
  mq,
  maxContentWidth,
  px2rem
} from '../../../stylesheets/tools';

const StyledStage = styled.section`
  ${maxContentWidth('1440px')}
  width: 100%;
  margin: 0 auto ${getSpace('xxl')};
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-top: ${getSpace('120px')};
  
  ${mq('m')} {
    padding-top: ${getSpace('xl')};
  }

  .stage__container {  
    overflow: hidden;
  }
  
  .stage__container .container__wrapper {
    ${mq('m')} {
      margin-bottom: ${getSpace('100px')};
    }
  }

  .stage__wrapper {
    position: relative;
    width: ${getGridSpan('12', 'normal')};

    ${mq('m')} {
      margin: ${getSpace('xxl')} 0 0;
    }

    h1,
    h3 {
      hyphens: auto;
      width: ${getGridSpan('10', 'normal')};

      ${mq('l')} {
        width: 100%;
      }
    }
  }

  .stage__categories {
    margin: 0 0 ${getSpace('xl')};
  }

  .stage__date {
    margin: ${getSpace('m')} 0 0;
    display: block;
    ${getTextType('copy', 'international')};
  }

  .stage__introduction {
    width: ${getGridSpan('11', 'normal')};
    margin: ${getSpace('m')} 0 ${getSpace('m')} ${getGridSpan('1', 'spread')};

    ${mq('m')} {
      width: ${getGridSpan('10', 'normal')};
    }
  }

  .stage__image--mobile {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: ${props =>
      props.imageFormat === 'landscape' ? 'calc(3 / 4 * 100%)' : 'calc(4 / 3 * 100%)'};
    display: block;
    margin: 0 0 10px;
    margin-left: ${getGridSpan('1', 'spread')};
    overflow: hidden;

    ${mq('m')} {
      width: ${getGridSpan('10', 'normal')};
      margin-left: ${getGridSpan('2', 'spread')};
      padding-bottom: ${props =>
        props.imageFormat === 'landscape' ? 'calc(3 / 4 * 83%)' : 'calc(4 / 3 * 83%)'};
    }

    ${mq('l')} {
      display: none;
      margin-left: 0;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .stage__credits {
    ${getTextType('copySmall', 'international')}
    margin-left: ${px2rem('85px')};
    margin-top: ${getSpace('xxs')};
    margin-bottom: ${getSpace('xxs')};
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
    width: ${getGridSpan('6', 'normal')};

    &--mobile {
      width: auto;
      text-align: right;
      opacity: 1;
      margin-left: ${px2rem('40px')};

      ${mq('l')} {
        display: none;
      }
    }

  }

  .stage__link {
    display: flex;
    align-items: center;

    svg {
      margin-right: ${getSpace('xxs')};
    }
  } 

  .lazyloaded ~ .stage__credits {
    opacity: 1;
  }

  .stage__image--desktop {
    display: none;
    position: absolute;
    width: ${getGridSpan('6', 'normal')};
    height: 0;
    margin-left: ${getGridGutter()};
    z-index: 1;

    ${mq('l')} {
      display: block;
    }

    ${props =>
      props.imageFormat === 'landscape' &&
      css`
        top: 130px;
        right: 0;

        img {
          width: 100%;
          height: auto;
        }
      `}

    ${props =>
      props.imageFormat === 'portrait' &&
      css`
        top: 0;
        left: ${getGridSpan('6', 'normal')};

        img {
          width: auto;
          height: 735px;
        }
      `}
  }

  ${props =>
    props.hasImage &&
    css`
      .stage__container .container__wrapper {
        ${mq('m')} {
          min-height: 605px;
        }
      }

      .stage__event-wrapper {
        ${mq('m')} {
          margin-top: -20px;
        }
      }

      .stage__wrapper {
        width: ${getGridSpan('12', 'normal')};

        ${mq('m')} {
          min-height: 550px;
        }

        ${mq('l')} {
          width: ${getGridSpan('5', 'normal')};
        }
      }

      .stage__introduction {
        width: 100%;
        margin-left: 0;
      }
    `}

  @media print {
    padding-top: 0;

    .stage__wrapper {
      margin: 0;
    }

    .stage__image--desktop {
      display: none;
    }

    .stage__image--mobile {
      margin: 0;
      padding: 0;

      img {
        height: 10cm;
        width: auto;
      }
    }
  }
`;

export default StyledStage;
